import { supabase } from './supabase'
import type { ConsumoPrevisto, NecessidadePeriodo } from '../types/database'

export interface ConsumoPrevistoFilters {
  inicio: string
  fim: string
  alimentoId?: string
  /** @deprecated use alimentoId */
  produtoId?: string
  rotaId?: string
  grupo?: string
  escolaId?: string
  /** Várias escolas (prioritário sobre escolaId). */
  escolaIds?: string[]
}

export async function fetchConsumoPrevisto(
  filters: ConsumoPrevistoFilters,
): Promise<{ data: ConsumoPrevisto[]; error: string | null }> {
  if (!filters.inicio || !filters.fim) {
    return { data: [], error: null }
  }

  const alimentoId = filters.alimentoId || filters.produtoId
  const escolaIds =
    filters.escolaIds?.length
      ? filters.escolaIds
      : filters.escolaId
        ? [filters.escolaId]
        : undefined

  const { data, error } = await supabase.rpc('consumo_previsto_periodo', {
    p_inicio: filters.inicio,
    p_fim: filters.fim,
    p_rota_id: filters.rotaId || null,
    p_escola_id: escolaIds?.length === 1 ? escolaIds[0] : null,
    p_escola_ids: escolaIds && escolaIds.length > 1 ? escolaIds : null,
    p_alimento_id: alimentoId || null,
    p_grupo: filters.grupo || null,
  })

  if (error) return { data: [], error: error.message }
  return { data: (data as ConsumoPrevisto[]) || [], error: null }
}

export async function fetchNecessidadePeriodo(params: {
  inicio: string
  fim: string
  rotaId?: string
  escolaId?: string
}): Promise<{ data: NecessidadePeriodo[]; error: string | null }> {
  const { data, error } = await supabase.rpc('necessidade_periodo', {
    p_inicio: params.inicio,
    p_fim: params.fim,
    p_rota_id: params.rotaId || null,
    p_escola_id: params.escolaId || null,
  })
  if (error) return { data: [], error: error.message }
  return { data: (data as NecessidadePeriodo[]) || [], error: null }
}
